export const authTranslations = {
  ru: {
    ban: {
      title: "Доступ ограничен",
      desc: "Ваш аккаунт был приостановлен из-за нарушения правил платформы. Использование сервиса временно или навсегда недоступно.",
      reasonTitle: "Причина блокировки",
      noReason: "Без указания причины",
      untilTitle: "Срок окончания",
      btnAccount: "Статус аккаунта",
      btnSupport: "Поддержка",
      btnShop: "Магазин",
      btnLogout: "Выйти"
    },
    reg: {
      bindTitle: "Требуется привязка",
      bindDesc: "У вас не привязан Minecraft Java или Bedrock аккаунт для завершения регистрации.",
      bindHowTo: "Как привязать аккаунт?",
      bindStep1: "Зайдите в Minecraft (Java или Bedrock)",
      bindStep2: "Подключитесь к нашему серверу",
      bindStep3: "Пройдите авторизацию в игре",
      bindStep4: "Нажмите кнопку «Обновить» ниже",
      btnCancel: "Отмена",
      btnChecking: "Проверка...",
      btnRefresh: "Обновить",
      finishTitle: "Завершение регистрации",
      finishDesc: "Выберите основной никнейм для вашего профиля.",
      javaTitle: "Minecraft Java",
      bedrockTitle: "Minecraft Bedrock",
      agreeTerms: "Я согласен с правилами сервера",
      btnCreating: "Создание...",
      btnCreate: "Создать"
    },
    menu: {
      balance: "Баланс",
      buyAccess: "Купить доступ",
      dashboard: "Личный кабинет",
      settings: "Аккаунт RoYoLands",
      adminPanel: "Панель управления",
      logout: "Выйти"
    }
  },
  en: {
    ban: {
      title: "Access Restricted",
      desc: "Your account has been suspended for violating platform rules. Service access is temporarily or permanently unavailable.",
      reasonTitle: "Ban Reason",
      noReason: "No reason specified",
      untilTitle: "Ban Expires",
      btnAccount: "Account Status",
      btnSupport: "Support",
      btnShop: "Store",
      btnLogout: "Log Out"
    },
    reg: {
      bindTitle: "Linking Required",
      bindDesc: "You don't have a Minecraft Java or Bedrock account linked to complete registration.",
      bindHowTo: "How to link an account?",
      bindStep1: "Launch Minecraft (Java or Bedrock)",
      bindStep2: "Connect to our server",
      bindStep3: "Authenticate in the game",
      bindStep4: "Click the 'Refresh' button below",
      btnCancel: "Cancel",
      btnChecking: "Checking...",
      btnRefresh: "Refresh",
      finishTitle: "Complete Registration",
      finishDesc: "Choose a primary nickname for your profile.",
      javaTitle: "Minecraft Java",
      bedrockTitle: "Minecraft Bedrock",
      agreeTerms: "I agree to the server rules",
      btnCreating: "Creating...",
      btnCreate: "Create"
    },
    menu: {
      balance: "Balance",
      buyAccess: "Buy Access",
      dashboard: "Dashboard",
      settings: "RoYoLands Account",
      adminPanel: "Control Panel",
      logout: "Log Out"
    }
  }
};